/* ==========================================================================
   HeaderMasterExpedient > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { take } = require('rxjs/operators');
const { fromEvent, of } = require('rxjs');
const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

const services = require('./services');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            headerMasterExpedient: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => {
                return this.store.dispatch(actions.destroy());
            },
            logout: () => {
                return this.store.dispatch(actions.logout());
            }
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Unsubscribe */
                this.unsubscribe();
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Clean DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean references */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            logout: this.store.subscribe((state, action) => {
                if (action.type !== types.LOGOUT) return;

                services
                    .logout(this.config.endpoints.logout)
                    .pipe(take(1))
                    .subscribe({
                        next: response => {
                            if (response.result) {
                                this.actions.destroy();
                            }
                        },
                        error: err => {
                            return of({ error: true, message: err.message });
                        }
                    });
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {
            logout: fromEvent(this.hooks.logout, 'click').subscribe(() => {
                this.actions.logout();
            })
        };

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },
    /* Start */
    start() {
        if (!this.config.start) return this;

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* Start */
        this.start();

        return this;
    }
};

/* Exports */
module.exports = prototype;
